/**
 * Created by Olexiy on 21.02.2017.
 */

(function($){
    $(document).ready(function() {

        function youTubeGetID(url){
            var ID = '';
            url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            if(url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
            }
            else {
                ID = url;
            }
            return ID;
        }

        $('.js-video').each(function(key,value) {
            var $imageContainer = $(value).find('.js-video-image');
            var url = $imageContainer.attr('data-video-link');
            $imageContainer.css('background-image','url(' + 'https://img.youtube.com/vi/' + youTubeGetID(url) + '/hqdefault.jpg' + ')');
        });

        $(".movies-slider").slick({
            slidesToShow: 2,
            autoplay:false,
            dots:false,
            fade:false,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            speed:300,
            infinite: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows:false
                }
            }]
        });

        $(".video").click(function() {
            var title = $(this).attr('data-fancybox-title');
            $.fancybox({
                'padding'       : 5,
                'autoScale'		: false,
                'fitToView'   : false,
                'autoSize'    : false,
                'transitionIn'	: 'none',
                'transitionOut'	: 'none',
                'width'			: 640,
                'height'		: 385,
                'href'			: this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
                "type": "iframe",
                helpers : {
                    title : { type : 'inside' }
                },
                afterLoad : function() {
                    this.title = title;
                }
            });

            return false;
        });



    });
})(jQuery);
